import { createSlice } from '@reduxjs/toolkit';

interface CarouselParameter {
  index: string;
  header?: {
    format: string;
    file: any;
    params?: Array<{ key: string; value: string }>;
  };
  body?: Array<{
    key: string;
    value_text: string;
    value: string;
    variable: string;
    type: 'name' | 'phonenumber' | 'fallback-value' | '' | string;
    example: string;
  }>;
  buttons?: Array<{
    index: string;
    type: string;
    value: string;
    variable: string;
    buttonUrlType: 'dynamic' | 'tracking' | 'static' | null;
  }>;
}

interface Parameter {
  header?: {
    format: string;
    file: any;
    params: Array<{ key: string; value: string }>;
  };
  body?: Array<{
    key: string;
    value_text: string;
    value: string;
    variable: string;
    type: 'name' | 'phonenumber' | 'fallback-value' | '' | string;
    example: string;
  }>;
  buttons?: Array<{
    index: string;
    type: string;
    value: string;
    variable: string;
    buttonUrlType: 'dynamic' | 'tracking' | 'static' | null;
  }>;
  carousel?: CarouselParameter[];
}

interface BroadcastSliceProps {
  item: {
    channel: { id: string; name: string };
    template: { id: string; name: string; attributes: any; headerMediaUrl?: string; CarouselHeader?: any[]; TemplateButton?: any[]; };
    group: { id: string; name: string };
    source: 'csv' | 'group' | 'all';
    broadcastFileId: string;
    groupId: string;
    name: string;
    isScheduled: 'now' | 'scheduled' | '';
    triggerAt: string;
    parameters: Parameter;
    date: string;
    time: string;
    csvRaw: any;
    showProduct: 'yes' | 'no';
    store: { df: string; name: string };
    hour: string;
    minute: string;
  };
}

const initialState: BroadcastSliceProps = {
  item: {
    channel: { id: '', name: '' },
    template: { id: '', name: '', attributes: [] },
    group: { id: '', name: '' },
    source: 'group',
    broadcastFileId: '',
    groupId: '',
    name: '',
    isScheduled: '',
    triggerAt: '',
    parameters: {},
    date: new Date().toISOString().slice(0, 10),
    time: new Date().toISOString().slice(11, 16),
    csvRaw: '',
    showProduct: 'no',
    store: { df: '', name: '' },
    hour: '00', //new Date().getHours().toString().padStart(2, '0'),
    minute: '00',
  },
};

export const broadcastSlice = createSlice({
  name: 'broadcast',
  initialState,
  reducers: {
    setParamater: (state, { payload }) => {
      state.item.parameters = payload;
    },
    setBroadcast: (state, { payload }) => {
      state.item = { ...payload };
    },
    resetBroadcast: (state) => {
      state.item = initialState.item;
    },
  },
});

export const { setBroadcast, setParamater, resetBroadcast } =
  broadcastSlice.actions;
